/** @module Main */
// First import: luxon must use the bundled tzdata before any zone is created (CN-2932).
import "./utils/tzdataZone";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import ProvideWrapper from "app/components/ProvideWrapper";
import "./i18n";
import "./styles/main.scss";
import App from "./App";
import { Loading } from "./components/Wrappers";
import { loadGrowthBook } from "./library/growthbook";

// Flags start loading now, so they are usually in before a paywall renders.
loadGrowthBook();

ReactDOM.render(
  (
    <Suspense fallback={<Loading isLoading loadType="spinner" />}>
      <ProvideWrapper>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ProvideWrapper>
    </Suspense>
  ),

  document.getElementById("root")
);
